/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 2V7M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 19L5.97354 16.9735C4.56608 15.5661 3.86235 14.8624 3.55863 14.0382C3.29101 13.3119 3.23982 12.5237 3.41126 11.769C3.60583 10.9124 4.21263 10.1236 5.42623 8.5459L9.4636 3.29732C10.3267 2.17534 10.7582 1.61435 11.2842 1.41274C11.745 1.23608 12.255 1.23608 12.7158 1.41274C13.2418 1.61435 13.6733 2.17534 14.5364 3.29732L18.5738 8.5459C19.7874 10.1236 20.3942 10.9124 20.5887 11.769C20.7602 12.5237 20.709 13.3119 20.4414 14.0382C20.1376 14.8624 19.4339 15.5661 18.0265 16.9735L16 19M7.5 22H16.5C17.3284 22 18 21.3284 18 20.5V20.5C18 19.6716 17.3284 19 16.5 19H7.5C6.67157 19 6 19.6716 6 20.5V20.5C6 21.3284 6.67157 22 7.5 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.5364 3.29732C13.6733 2.17534 13.2418 1.61435 12.7158 1.41274C12.255 1.23608 11.745 1.23608 11.2842 1.41274C10.7582 1.61435 10.3267 2.17534 9.4636 3.29732L5.42623 8.54591C4.21263 10.1236 3.60583 10.9124 3.41126 11.769C3.23982 12.5237 3.29101 13.3119 3.55863 14.0382C3.86235 14.8624 4.56608 15.5661 5.97354 16.9735L8 19H16L18.0265 16.9735C19.4339 15.5661 20.1376 14.8624 20.4414 14.0382C20.709 13.3119 20.7602 12.5237 20.5887 11.769C20.3942 10.9124 19.7874 10.1236 18.5738 8.5459L14.5364 3.29732ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
				fill="currentColor"
			/>
			<path
				d="M8 19L5.97354 16.9735C4.56608 15.5661 3.86235 14.8624 3.55863 14.0382C3.29101 13.3119 3.23982 12.5237 3.41126 11.769C3.60583 10.9124 4.21263 10.1236 5.42623 8.5459L9.4636 3.29732C10.3267 2.17534 10.7582 1.61435 11.2842 1.41274C11.745 1.23608 12.255 1.23608 12.7158 1.41274C13.2418 1.61435 13.6733 2.17534 14.5364 3.29732L18.5738 8.5459C19.7874 10.1236 20.3942 10.9124 20.5887 11.769C20.7602 12.5237 20.709 13.3119 20.4414 14.0382C20.1376 14.8624 19.4339 15.5661 18.0265 16.9735L16 19M12 2V7M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM7.5 22H16.5C17.3284 22 18 21.3284 18 20.5V20.5C18 19.6716 17.3284 19 16.5 19H7.5C6.67157 19 6 19.6716 6 20.5V20.5C6 21.3284 6.67157 22 7.5 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_6420)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.2499 2.56739C11.2499 1.70529 11.2499 1.27424 11.0906 1.10182C10.9528 0.952654 10.7489 0.883305 10.5488 0.917528C10.3174 0.957082 10.0546 1.29874 9.52897 1.98207L4.24995 8.84479C3.71438 9.54103 3.44659 9.88915 3.26173 10.2256C2.32585 11.9288 2.46166 14.02 3.60997 15.5878C3.83679 15.8975 4.14735 16.2081 4.76848 16.8292C5.01338 17.0741 5.13584 17.1966 5.26347 17.3045C5.89813 17.8411 6.68417 18.1667 7.51238 18.236C7.67894 18.25 7.85212 18.25 8.19847 18.25H15.8013C16.1477 18.25 16.3208 18.25 16.4874 18.236C17.3156 18.1667 18.1016 17.8411 18.7363 17.3045C18.8639 17.1966 18.9864 17.0741 19.2313 16.8292C19.8524 16.2081 20.163 15.8975 20.3898 15.5878C21.5381 14.02 21.6739 11.9288 20.738 10.2256C20.5532 9.88915 20.2854 9.54103 19.7498 8.84479L14.4708 1.98207C13.9452 1.29874 13.6824 0.957082 13.451 0.917528C13.2508 0.883305 13.0469 0.952654 12.9091 1.10182C12.7499 1.27424 12.7499 1.70529 12.7499 2.56739V6.99996C12.7499 7.41417 12.4141 7.74996 11.9999 7.74996C11.5857 7.74996 11.2499 7.41417 11.2499 6.99996V2.56739ZM13.9999 12C13.9999 13.1045 13.1045 14 11.9999 14C10.8953 14 9.99989 13.1045 9.99989 12C9.99989 10.8954 10.8953 9.99996 11.9999 9.99996C13.1045 9.99996 13.9999 10.8954 13.9999 12Z"
					fill="currentColor"
				/>
				<path
					d="M5.24989 21C5.24989 20.0335 6.03339 19.25 6.99989 19.25H16.9999C17.9664 19.25 18.7499 20.0335 18.7499 21C18.7499 21.9665 17.9664 22.75 16.9999 22.75H6.99989C6.03339 22.75 5.24989 21.9665 5.24989 21Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_6420">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18.5 16.5L19 16V16C19.4859 15.5141 19.7289 15.2711 19.9071 15.0295C20.8358 13.7704 20.9453 12.0855 20.1872 10.7169C20.0417 10.4542 19.8322 10.1819 19.4132 9.63718L14.5364 3.29732C13.6733 2.17534 13.2418 1.61435 12.7158 1.41274C12.255 1.23608 11.745 1.23608 11.2842 1.41274C10.7582 1.61435 10.3267 2.17534 9.4636 3.29732L5.42623 8.5459C4.21263 10.1236 3.60583 10.9124 3.41126 11.769C3.23982 12.5237 3.29101 13.3119 3.55863 14.0382C3.86235 14.8624 4.56608 15.5661 5.97354 16.9735L6.59411 17.5941C7.11297 18.113 7.3724 18.3724 7.67515 18.5579C7.94356 18.7224 8.2362 18.8436 8.5423 18.9171C8.88757 19 9.25445 19 9.98823 19H16.5C17.3284 19 18 19.6716 18 20.5V20.5C18 21.3284 17.3284 22 16.5 22H8M12 2V7M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 19L5.97354 16.9735C4.56608 15.5661 3.86235 14.8624 3.55863 14.0382C3.29101 13.3119 3.23982 12.5237 3.41126 11.769C3.60583 10.9124 4.21263 10.1236 5.42623 8.5459L9.4636 3.29732C10.3267 2.17534 10.7582 1.61435 11.2842 1.41274C11.745 1.23608 12.255 1.23608 12.7158 1.41274C13.2418 1.61435 13.6733 2.17534 14.5364 3.29732L18.5738 8.5459C19.7874 10.1236 20.3942 10.9124 20.5887 11.769C20.7602 12.5237 20.709 13.3119 20.4414 14.0382C20.1376 14.8624 19.4339 15.5661 18.0265 16.9735L16 19M12 2V7M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM7.5 22H16.5C17.3284 22 18 21.3284 18 20.5V20.5C18 19.6716 17.3284 19 16.5 19H7.5C6.67157 19 6 19.6716 6 20.5V20.5C6 21.3284 6.67157 22 7.5 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_6415)">
				<path
					opacity="0.32"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.01031 18.0713C4.23821 16.2992 3.35216 15.4131 2.97281 14.3762C2.63859 13.4626 2.57813 12.4714 2.79882 11.524C3.04933 10.4486 3.82112 9.46145 5.36469 7.48709L8.21847 3.83688C9.50766 2.1879 10.1523 1.36341 10.935 1.06618C11.6211 0.805673 12.3789 0.805677 13.0649 1.0662C13.8477 1.36343 14.4923 2.18793 15.7815 3.83692L18.6352 7.48711C20.1787 9.46146 20.9505 10.4486 21.201 11.524C21.4217 12.4714 21.3612 13.4626 21.027 14.3762C20.6476 15.4131 19.7616 16.2992 17.9895 18.0712L16.8105 19.2502H7.18923L6.01031 18.0713Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V6C11.25 6.41421 11.5858 6.75 12 6.75C12.4142 6.75 12.75 6.41421 12.75 6V1ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM7 19.25C6.0335 19.25 5.25 20.0335 5.25 21C5.25 21.9665 6.0335 22.75 7 22.75H17C17.9665 22.75 18.75 21.9665 18.75 21C18.75 20.0335 17.9665 19.25 17 19.25H7Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_6415">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
